"use strict";function t(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}const e={routerNavigate:void 0},r=t(require("react")).default.createContext(e);exports.RouterContext=r;
//# sourceMappingURL=RouterContext-DLx4w1Wq.js.map
